import { SearchResponse } from '@empathy/search-adapter';
import { Tagging } from '@empathy/search-types';
import { GridItem, SearchState, SUBMODULES_PATHS } from '@empathybroker/ebx-gluon';
import { RootStoreState } from '@empathybroker/ebx-gluon/dist/store';
import { StoreOptions } from 'vuex';

export const STORE_CONFIG: StoreOptions<RootStoreState> = {
  modules: {
    [SUBMODULES_PATHS.search]: {
      state: {
        blogPosts: []
      },
      mutations: {
        saveSearchResponse(searchState: SearchState, searchResponse: Partial<SearchState>) {
          // TODO When updated, extend the SaveSearchResponse mutation instead of duplicating code.
          if (searchState.keepPreviousResults) {
            searchState.results.push(...searchResponse.results ?? []);
            searchState.banners.push(...searchResponse.banners ?? []);
            searchState.promoteds.push(...searchResponse.promoteds ?? []);
            searchState.keepPreviousResults = false;
          } else {
            searchState.results = searchResponse.results ?? [];
            searchState.banners = searchResponse.banners ?? [];
            searchState.promoteds = searchResponse.promoteds ?? [];
          }
          searchState.facets = searchResponse.facets ?? {};
          searchState.partialResults = searchResponse.partialResults ?? [];
          searchState.queryTagging = searchResponse.queryTagging ?? {} as Tagging;
          searchState.directs = searchResponse.directs ?? [];
          searchState.spellcheck = searchResponse.spellcheck ?? '';
          searchState.numFound = searchResponse.numFound ?? 0;
          // Save blog posts to the state
          searchState.blogPosts = searchResponse.blogPosts ?? [];
        }
      },
      getters: {
        gridItemsWithBlogPosts(state: SearchState, getters: any) {
          const items: (GridItem | {})[] = [...getters.gridItems];
          if (state.blogPosts.length && !window.location.href.includes('aprendeymejora')) {
            const blog = {
              id: 'blog',
              modelName: 'Blog',
              posts: state.blogPosts
            };
            items.splice(8, 0, blog);
          }
          return items;
        },
        isBlog(): boolean {
          return window.location.href.includes('aprendeymejora');
        }
      }
    }
  }
};
